import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search'; 
import { TextField } from '@mui/material';
import { useState } from 'react'


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function SupportingDocuments({ doc }) {
    const [searchTerm, setSearchTerm] = useState('');

    // Function to filter documents based on the search term
    const filteredDoc = doc.filter((categoryData) => {
        return categoryData.category.toLowerCase().includes(searchTerm.toLowerCase()) || // Include category in search
            categoryData.documents.some((docData) =>
                docData.documentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                docData.documentType.toLowerCase().includes(searchTerm.toLowerCase())
            );
    });
    function formatDateAndTime(dateTime) {
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        
        minute: '2-digit',
        second:'2-digit',
        hour12: true,
      };
      const formattedDate = new Date(dateTime).toLocaleString(undefined, options);
    
      // Replace the comma after the date with a space
      const formattedDateWithoutComma = formattedDate.replace(/,/, '');
    
      return formattedDateWithoutComma.toUpperCase();
    }
    return (
        <>
         <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec">
      {/* <div className='mx-3 mt-3 mb-3'>
        <TextField
         placeholder={"Search"} 
          size='small'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              searchTerm ? null : <SearchIcon style={{ color: 'gray' }} />
            ),
          }}
        />
      </div> */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell className='text-muted' sx={{ width: "15%" }}></StyledTableCell>
              <StyledTableCell className='text-muted'>Document</StyledTableCell>
              <StyledTableCell className='text-muted'>Type</StyledTableCell>
              <StyledTableCell className='text-muted'sx={{ width: "15%" }}>Uploaded</StyledTableCell>
              <StyledTableCell className='text-muted'sx={{ width: "15%" }}>Last Updated</StyledTableCell>
              <StyledTableCell className='text-muted'sx={{ width: "15%" }}>Expires</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredDoc?.length === 0 ? ( // Check if there are no search results
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No results found.
                </TableCell>
              </TableRow>
            ) : (
              filteredDoc?.map((categoryData) => (
                <>
                  <TableRow>
                    <StyledTableCell colSpan={6} className='text-muted' sx={{ backgroundColor: "#F2F4F7", }}>
                      {categoryData?.category}
                    </StyledTableCell>
                  </TableRow>
                  {categoryData?.documents.map((docData) => (
                    <StyledTableRow key={docData.documentId}>
                      <StyledTableCell align="left">&nbsp;</StyledTableCell>
                      <StyledTableCell align="left">{docData.documentName}</StyledTableCell>
                      <StyledTableCell align="left">{docData.documentType}</StyledTableCell>
                      <StyledTableCell align="left">{formatDateAndTime(docData.uploadedOn)} by {docData.uploadedBy}</StyledTableCell>
                      <StyledTableCell align="left">{formatDateAndTime(docData.modifiedOn)} by {docData.modifiedBy}</StyledTableCell>
                      <StyledTableCell align="left" hidden={!docData.expirationDate}>{formatDateAndTime(docData.expirationDate)}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
        </>
    )
}